import GenerateFieldWithAI from './GenerateFieldWithAI';

export default GenerateFieldWithAI;